export const EmailWriterDetailsSectionSkeleton = () => (
  <div className="flex w-full flex-col gap-4" data-testid="email-writer-details-section-skeleton">
    <div className="h-[18px] w-full max-w-[502px] rounded bg-gray-200" />
    <div className="h-[18px] w-full max-w-[440px] rounded bg-gray-200" />
  </div>
);
